"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("./index"));
var CheckBox_1 = __importDefault(require("../../Input/CheckBox"));
var CheckboxFilterItem = /** @class */ (function (_super) {
    __extends(CheckboxFilterItem, _super);
    function CheckboxFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validOperators = ["in"];
        _this.onChangeCheckbox = function () {
            var newValue = _this.state.selectedValues === "true" ? "false" : "true";
            _this.setState({
                selectedValues: newValue,
            });
            _this.props.onChange(_this.props.id, newValue, _this.props.operator ? _this.props.operator : CheckboxFilterItem.defaultOperator);
        };
        _this.renderDropdownBody = function () {
            // @TODO Not implemented yet
            return null;
        };
        _this.renderLabel = function () {
            var selectedValues = _this.state.selectedValues;
            var label = _this.props.label || Array.isArray(_this.props.id) ? _this.props.id.toString() : _this.props.id;
            var value = "";
            if (Array.isArray(selectedValues)) {
                value = selectedValues[0] ? selectedValues[0].toString() : "";
            }
            else if (selectedValues) {
                value = selectedValues.toString();
            }
            return (react_1.default.createElement("div", { className: "checkbox_container" },
                react_1.default.createElement(CheckBox_1.default, { value: value === "true", onChange: _this.onChangeCheckbox, ownLabel: label })));
        };
        return _this;
    }
    return CheckboxFilterItem;
}(index_1.default));
exports.default = CheckboxFilterItem;
//# sourceMappingURL=CheckboxFilterItem.js.map